<!-- modal de confirmação de exclusão do sistema -->
<template>
  <div id="modal-excluir">
    <div class="modal fade" id="modalExcluir" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
              <h4 class="modal-title" id="myModalLabel">Confirmar Exclusão</h4>
            </div>
            <div class="modal-body">
              <center>
                Deseja realmente excluir os itens selecionados?
              </center>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-default" data-dismiss="modal">NÃO</button>
              <button type="button" class="btn btn-danger" @click="excluir">SIM</button>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>
<script>
export default {
  name: "modal-excluir",
  data(){
    return{

    }

  },
  methods: {

        excluir() {
           this.$emit('confirmado')
        }
  }

}
</script>




<style lang="scss" scoped>
</style>
